const userManagerSettings = {
  authority: 'https://sso.tesouro.gov.br/auth/realms/interno',
  client_id: 'cliente-aria',
  redirect_uri: window.location.href
};
export default userManagerSettings;